export default {

  namespaced: true,

  state: () => ({

    export_product: {},
    products: { products: {} },
    cargaTXT: {},
    product: {},
    ibpt: {},

    internalBarcode: [],
    searchParams: {},

    newProduct: null,

    productTagParams: {}
  }),

  mutations: {
    setProducts(state, data) {
      state.products = data
    },

    setProduct(state, data) {
      state.product = data
    },

    setNewProduct(state, data) {
      state.newProduct = data
    },

    setIbpt(state, data) {
      state.ibpt = data
    },

    setExportProduct(state, data) {
      state.export_product = data
    },

    setCargaTXT(state, data) {
      state.cargaTXT = data
    },

    createCodeBar(state, data) {
      let internalBarcode = {

        codebar: data.img_base64,
        id: data.product.id,
        sku: data.product.base_sku_id,
        description: data.product.description,
        price: data.product.price,
        price_immediate: data.product.price_immediate

      }

      state.internalBarcode.push(internalBarcode);
    },

    removeCodeBar(state, code) {

      let codeIndex = state.internalBarcode.map(row => row.id).indexOf(code)

      state.internalBarcode.splice(codeIndex, 1);
    },
    setSearchParams(state, data) {
      state.searchParams = data
    },
    setTagParams(state, params) {
      state.productTagParams = params
    }

  },

  actions: {

    async getProducts({ dispatch, commit }, params) {
      
      let response = await axios.get("/erp/product/product", { params: params })
      
      commit('setProducts', response.data)  
      
      return response.data
    },

    async getProduct({ dispatch, commit }, id) {
      await axios.get("/erp/product/product/" + id)
        .then(response => {
          commit('setProduct', response.data)
        }).catch(error => { console.log(error) })
    },

    async getProductLegacy({ dispatch, commit }, id) {
      let response = await axios.get("/erp/product/product-legacy/" + id)

      return response.data
    },

    storeProduct({ $axios, commit }, { form, id }) {

      if (id) {

        let url = "/erp/product/product"

        url = url + '/' + id

        return new Promise((resolve, reject) => {
          axios.put(url, form)
            .then(response => {
              resolve(response)
            }).catch(error => {
              reject(error)
            });
        })


      } else {
        return new Promise((resolve, reject) => {
          axios.post("/erp/product/product", form)
            .then(response => {
              resolve(response)
            }).catch(error => {
              reject(error)
            });
        })
      }
    },


    async getIbpt({ dispatch, commit }, params) {

      return new Promise((resolve, reject) => {
        axios.get("/erp/product/ibpt", { params: params })
          .then(response => {
            commit('setIbpt', response.data)
            resolve(response)
          }).catch(error => {
            reject(error)
          });
      })
    },

    async exportProducts({ dispatch, commit }) {
      await axios({
        url: '/erp/product/export', method: 'POST', responseType: 'blob'
      })
        .then(response => {
          commit('setExportProduct', response)
        }).catch(error => { console.log(error) })
    },

    async getCargaTXT({ dispatch, commit }, params) {

      await axios.get("/erp/product/cargatxt")
        .then(response => {
          commit('setCargaTXT', response)
        }).catch(error => { console.log(error) })
    },

    async getInternalBarCodeHtml({ commit }, id) {
      const data = await axios.get('/erp/product/bar-code/' + id);

      commit('createCodeBar', data.data);


      return data;
    },

    async getProductsReport({ commit }, params) {
      const data = await axios.get('/erp/product/report', { params: params });
      return data;
    },
    
    async getStockAudit({ commit }, params) {
      const data = await axios.get('/erp/product/stock-audit', { params: params });
      return data;
    }
  }
}
